(self["webpackChunktvg_shopify_theme"] = self["webpackChunktvg_shopify_theme"] || []).push([[428],{

/***/ 432:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

"use strict";

// UNUSED EXPORTS: default

// EXTERNAL MODULE: ./node_modules/.pnpm/@hotwired+stimulus@3.2.2/node_modules/@hotwired/stimulus/dist/stimulus.js
var stimulus = __webpack_require__(3759);
// EXTERNAL MODULE: ./_components/customer/storefront-repository.js + 8 modules
var storefront_repository = __webpack_require__(540);
;// CONCATENATED MODULE: ./_components/customer/storefront-repository/bundle-selection-loader.js
// This class is responsible for loading the last 10 bundle selections
// for the current customer and enriching them with subscription and
// address information.
class BundleSelectionLoader {
  #sessionValue;

  async load() {
    this.#sessionValue = await window.recharge.auth.loginShopifyAppProxy()
    const subscriptions = await this.#fetchSubscriptions()
    const bundleSelections = await this.#fetchBundleSelections(subscriptions.map(sub => sub.id))

    return (await Promise.all(
      subscriptions
        .map(subscription => ({
          subscription,
          bundleSelection: bundleSelections.find(bundle => bundle.purchase_item_id === subscription.id)
        }))
        .filter(({ subscription, bundleSelection }) => bundleSelection !== undefined)
        .map(async ({ subscription, bundleSelection }) => {
        const address = await this.#fetchAddress(subscription.address_id)
        const customizationMakeup = this.#fetchCustomizationMakeup(subscription)

        return ({
          ...bundleSelection,
          subscription,
          address,
          customizationMakeup
        })
      })
    ))
  }

  async #fetchSubscriptions() {
    try {
      const res = await window.recharge.subscription.listSubscriptions(
        this.#sessionValue,
        {
          limit: 25,
          sort_by: 'updated_at-desc',
          status: 'active'
        }
      )
      return res.subscriptions || []
    } catch (e) {
      console.warn('Failed to fetch subscriptions', e)
      return []
    }
  }

  async #fetchBundleSelections(subscriptionIds) {
    try {
      const res = await window.recharge.bundle.listBundleSelections(
        this.#sessionValue,
        {
          sort_by: 'updated_at-asc',
          purchase_item_ids: subscriptionIds
            .join(',')
        }
      )
      return res.bundle_selections || []
    } catch (e) {
      console.warn('Failed to fetch bundles', e)
    }
  }

  async #fetchAddress(addressId) {
    try {
      const res = await window.recharge.address.getAddress(
        this.#sessionValue,
        addressId
      )
      return res || {}
    } catch (e) {
      console.warn('Failed to fetch address', e)
    }
  }

  #fetchCustomizationMakeup(subscription) {
    try {
      const customizationProperty = subscription.properties.find(
          (property) => property.name === 'Customization Makeup'
        )
      return JSON.parse(customizationProperty['value'])
    } catch (e) {
      console.warn(
        'Failed to parse customization makeup property for subscription'
      )
    }
  }
}

// EXTERNAL MODULE: ./_components/core/cart/index.js + 33 modules
var cart = __webpack_require__(2674);
;// CONCATENATED MODULE: ./_components/core/recharge.js
// Navigates the customer to the Recharge portal
async function navigateToRechargePortal() {
    window.location.href = `/tools/recurring/login?redirect=customer_portal%2Fcustomer`;
}
// Navigates the customer to a Recharge Quick action to process their next order immediately.
async function processNow(subscriptionId) {
    window.location.href = `https://account.cometeer.com/account?send_now=${subscriptionId}`;
}

// EXTERNAL MODULE: ./_components/core/shopify/format-money.js
var format_money = __webpack_require__(2549);
// EXTERNAL MODULE: ./_components/theme/constants.js
var constants = __webpack_require__(5711);
;// CONCATENATED MODULE: ./_components/theme/testing.js
const checkFivePackTag = function () {
  return window.Customer?.tags?.includes("5 Pack Min")
}

// EXTERNAL MODULE: ./node_modules/.pnpm/dayjs@1.11.11/node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(7672);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./_components/customer/value-from-cookie.js
var value_from_cookie = __webpack_require__(969);
// EXTERNAL MODULE: ./_components/customer/utils.js
var utils = __webpack_require__(157);
// EXTERNAL MODULE: ./_components/core/factories/cart-items-factory.js
var cart_items_factory = __webpack_require__(413);
;// CONCATENATED MODULE: ./_components/sections/byo/index.js













class ByoController extends stimulus.Controller {
  static targets = [
    'productCard',
    'productCardTemplate',
    'productCategory',
    'smsModal',
    'smsConfirmationModal',
    'smsPhoneNumberConfirmation',
    'smsNumPacks',
    'sessionClearButton',
    'stateSelector',
    'stateSelectorSelect',
    'loadingSpinner',
    'hideWhenLoading',
    'subscriptions',
    'subscriptionBlockTemplate',
    'phoneNumberInput',
    'trayOverlay',
    'trayDetailsButton',
    'trayDetails',
    'cta',
    'onetimePrice',
    'subscribePrice',
    'tray',
    'trayContainer',
    'onetimePriceUnit',
    'subscribePriceUnit',
    'discountText',
    'traySummary',
    'traySlotTemplate',
    'traySlot',
    'trayProductTemplate',
    'flashMessageTemplate',
    'flashContainer',
    'addProductButton',
    'sellingPlans',
    'sleeve4Text',
    'sleeve5Text',
    'sleeve6Text',
    'sleeveCounter',
    'subscriptionUpdateDialog',
    'updatedSubscriptionDate',
    'updatedSubscriptionArrivalDate',
    'updatedSubscriptionAddress',
    'updatedSubscriptionItems',
    'updatedSubscriptionItemTemplate',
    'sellingPlanSelector',
    'category',
    'feedbackContainer',
    'ctaInput',
    'inlineStateSelector',
    'subscriptionSelector',
    'subtitle',
    'drawerSummary'
  ]
  static outlets = ['byo-product-modal', 'byo-subscriptions', 'byo-filters', 'inline-state-selector', 'sidecart']
  static values = {
    session: Object,
    selectedBundleId: Number,
    activeBundles: Array,
    customerState: String,
    bundleProductId: Number,
    bundleVariantId: Number,
    bundleProductHandle: String,
    bundleSettings: Object,
    discountCode: String,
    trayExpanded: Boolean,
    hideTrayInitially: Boolean,
    selectedProducts: Array,
    addingProduct: Boolean,
    collectionId: String,
    inStockSkus: Array,
    displayOtpButtonText: Boolean,
    stateSelectorDelayed: Boolean,
    subscriberOtp: Boolean,
    discountCodes: Array,
    presetSleeves: Array,
    showSubscriptionPrice: Boolean,
    minSleevesForIntervalSelector: Number,
    validStates: Array,
    allowDatePicker: Boolean,
  }

  async connect() {
    if(this.hideTrayInitiallyValue) {
      this.trayContainerTarget.classList.add('hidden')
    }

    // Settings for the parent bundle
    try {
      this.bundleSettingsValue = await storefront_repository["default"].getBundleSettings(this.bundleProductIdValue)
    } catch (error) {
      console.error('Failed to fetch bundle settings.')
    }

    // Load existing subscription data
    if (!this.subscriberOtpValue) {
      this.sessionValue = await window.recharge.auth.loginShopifyAppProxy()
      await this.loadBundles()
    }

    // Set initial state for cart operations
    this.pendingCartUpdate = false
    this.cartUpdateInProgress = false

    this.readBundleFromCart()
    this.setSubscriptionFromUrl()
    this.loadInitialModals()
    this.sellingPlanSelectorReinforcement()
    this.detectUserLocation()
  }

  newBundle() {
    return this.activeBundlesValue.length === 0
  }

  async readBundleFromCart() {
    if (!this.newBundle()) return

    const bundleItems = this.sidecartOutlet.firstBundleItemsExpandedByQuantity()

    if (bundleItems.length === 0) {
      this.selectedProductsValue = []
      this.bundleFromCart = true
      this.needsUpdate = false
      this.existingBundleInCart = false
      return
    }

    this.existingBundleInCart = true
    this.bundlePriceFromCart = this.calculateBundlePriceFromCart(bundleItems)

    const { updatedProducts, productsToAdd, productsToRemove } = this.processBundleItems(
      bundleItems,
      this.selectedProductsValue
    )

    if (this.pendingCartUpdate) {
      // Another cart update is pending, it will handle setting the tray from the cart. We'll skip it here
      // to avoid overwriting user changes to the tray.
      return
    }

    this.selectedProductsValue = updatedProducts.filter(product => !productsToRemove.includes(product))
    for (const product of productsToAdd) {
      await this.addProduct(product.merchandise.product.id, product)
    }

    // Changing selectedProducts triggers a tray update, but in some circumstances selectedProducts
    // doesn't actually change, but we still need a tray details update. E.g. removing a single
    // roast from a tray with multiple items.
    this.updateTrayDetails()

    this.bundleFromCart = true
    this.needsUpdate = false
  }

  calculateBundlePriceFromCart(bundleItems) {
    // We get duplicates from the cart, because BYO displays them as individual items,
    // so we need to deduplicate here with a set.
    return [...new Set(bundleItems.map(item => item.id))]
      .map(id => bundleItems.find(item => item.id === id))
      .reduce((total, item) => total + parseFloat(item.cost.totalAmount.amount), 0)
  }

  processBundleItems(bundleItems, previousProducts) {
    // We want to maintain the same ordering of products as the previous tray.
    const result = bundleItems.reduce((acc, item) => {
      const matchingIndex = this.findMatchingProductIndex(item, previousProducts)

      if (matchingIndex !== -1) {
        previousProducts[matchingIndex] = { ...previousProducts[matchingIndex], "handled": true }
        acc.updatedProducts[matchingIndex] = { ...acc.updatedProducts[matchingIndex], item }
      } else {
        acc.productsToAdd.push(item)
      }

      return acc
    }, { 
      updatedProducts: [...previousProducts], 
      productsToAdd: []
    })

    // Any remaining products in previousProducts were not found in bundleItems
    // and should be added to productsToRemove
    result.productsToRemove = previousProducts

    return result
  }

  findMatchingProductIndex(item, products) {
    return products.findIndex(product => {
      return ((0,utils.ensureGid)('Product', product.id) === (0,utils.ensureGid)('Product', item.merchandise.product.id)) && !product.handled
    })
  }

  setSubscriptionFromUrl() {
    const searchParams = new URLSearchParams(window.location.search)
    const subscriptionId = searchParams.get('subscription_id')

    if (subscriptionId) {
      const subscription = this.#supportedSubscriptions().find(
        (selection) => selection.subscription.id === parseInt(subscriptionId)
      )

      if (!subscription) return

      this.selectedBundleIdValue = subscription.id
    }
  }

  toggleFivePack(enabled = true) {
    // Sets minimum sleeves to 5 and updates some of the language
    this.fivePackEnabled = enabled
    this.subtitleTargets.forEach(el => {
      el.innerText = enabled ? "Choose 5 - 10 packs" : "Choose 4 - 10 packs"
    })
    this.drawerSummaryTargets.forEach(el => {
      el.innerHTML = enabled ? "<b>Choose 5-10 packs</b>" : "<b>Choose 4-10 packs</b>"
    })
    this.updateTrayDetails()
  }

  trayHasProductsWithoutCartItem() {
    return this.selectedProductsValue.some(product => !product.item)
  }

  async updateCartBundleWithLock(retryCount = 0) {
    if (this.pendingCartUpdate && !this.cartUpdateInProgress) {
      // We need to update the cart, and we are not in the middle of an update,
      // so we can fire away and release the pending cart update lock.
      this.cartUpdateInProgress = true
      this.pendingCartUpdate = false

      await this.updateCartBundle()
      await this.readBundleFromCart()

      // Cart update is done, we can release the lock to allow any other pending updates
      // to happen.
      this.cartUpdateInProgress = false
    } else if (this.pendingCartUpdate) {
      if (retryCount > 10) {
        // If for some reason we're stuck in a loop, reset the lock and proceed.
        // Otherwise, there's no way for the user to recover. This can lead to the
        // cart overwriting the tray though, so report it as an error.
        console.error("BYO: Max retries reached, resetting cart update lock.")
        this.cartUpdateInProgress = false
        this.updateCartBundleWithLock()
      } else {
        // We are already in the middle of an update, so we need to wait for it to complete
        // before starting another one. Try again in 500ms.
        setTimeout(() => this.updateCartBundleWithLock(retryCount + 1), 500)
      }
    } else {
      // The cart doesn't need to be updated again. This can happen when multiple updates to
      // the cart are pending (since a single update will sync the cart and tray fully)
      return
    }
  }

  bundleToCartItems() {
    return cart_items_factory.CartItemsFactory.create({
      sellingPlanId: this.sellingPlanName(),
      allowDatePicker: this.allowDatePickerValue,
      minQty: this.minQty(),
      source: 'customer',
      bundleItems: this.selectedProductsValue.map(product => {
        const selectedPlan = product.sellingPlanGroups.nodes[0].sellingPlans.nodes.filter((p) => p.name.toLowerCase() === this.sellingPlanName().toLowerCase()).pop()

        return {
          variantId: product.variantId,
          productId: product.id,
          quantity: product.quantity,
          sellingPlanId: selectedPlan?.id,
        }
      }),
      bundleProductHandle: this.bundleProductHandleValue,
      bundleCollectionId: this.collectionIdValue,
      bundleProductId: this.bundleProductIdValue,
      bundleVariantId: this.bundleVariantIdValue,
    })
  }

  async updateCartBundle() {
    // Prevent this from running if the user has not changed the bundle, as this will
    // trigger on page load + initial population.
    const needsUpdate = this.needsUpdate || this.trayHasProductsWithoutCartItem()
    if (!needsUpdate || !this.newBundle()) {
      return
    }

    if (this.existingBundleInCart) {
      await this.sidecartOutlet.updateCartFromTray(this.selectedProductsValue)
    } else {
      // New bundle, so we need to add the products to the cart.
      await this.sidecartOutlet.addItems(this.bundleToCartItems())
      await this.sidecartOutlet.setDiscountCodes(this.discountCodesValue)
      await this.sidecartOutlet.fetchCart()
    }
  }

  detectUserLocation() {
    const user_ip_address = storefront_repository["default"].getIPAddress()
    user_ip_address.then((ip_address) => {
      if (ip_address) {
        const user_location = storefront_repository["default"].getLocationFromIPAddress(ip_address)
        user_location.then((location) => {
          if (location?.region_name && this.validStatesValue.includes(location.region_name)) {
            this.customerStateValue = location.region_name

            this.fireGtag('IP Location Detected and Set')
          }
        })
      }
    })
  }

  loadInitialModals() {
    const searchParams = new URLSearchParams(window.location.search)
    const productId = searchParams.get('product_id')
    const stateLocation = searchParams.get('state')
    this.mallAssociateName = searchParams.get('associate')
    this.mallName = searchParams.get('mall')

    if (stateLocation) {
      this.customerStateValue = stateLocation
      this.placeholderStateSelected = false
    } else if (this.stateSelectorDelayedValue === true && this.customerStateValue === '') {
      // Set default state until a user selects one
      this.customerStateValue = 'Massachusetts'
      this.placeholderStateSelected = true
    } else if (this.hasInlineStateSelectorTarget) {
      // If using the inline state selector, default to Massachusetts.
      this.customerStateValue = 'Massachusetts'
    }

    if (productId) {
      // Show product modal if product is deep linked
      this.openProductModal(productId)
    } else if (this.newBundle() && !this.customerStateValue && !this.stateSelectorDelayedValue) {
      // If the user has no active subscriptions, show the state selector
      this.showStateSelector()
    }

    this.hideWhenLoadingTargets.forEach((el) => el.classList.remove('hidden'))
    if (this.hasLoadingSpinnerTarget) {
      this.loadingSpinnerTarget.classList.add('hidden')
    }
  }

  // We should remove this at some point -- handles a bug when moving back in the browser
  // Navigating to the cart then hitting the back button causes the selector value to not be set
  // Which causes the products added to cart to be non-subscription
  sellingPlanSelectorReinforcement() {
    if (this.hasSellingPlanSelectorTarget) {
      this.activeSellingPlanSelector().value = this.activeSellingPlanSelector().querySelector('option[selected]')?.value
    }
  }

  afterStateSelected() {
    this.loadPreset()
  }

  async loadPreset() {
    if (this.newBundle()) {
      for (const presetSleeveId of this.presetSleevesValue) {
        await this.addProduct(presetSleeveId)
      }
    }
  }

  toggleTray(e) {
    e.preventDefault()

    if (e.target.dataset.productId && this.trayExpandedValue) {
      // When you click the product image on the expanded tray, show the info modal in addition to closing the tray
      this.openProductModal(e.target.dataset.productId)
    }

    this.trayExpandedValue = !this.trayExpandedValue

    this.dispatch("trayToggled", { detail: {
        expanded: this.trayExpandedValue
      }})
  }

  async openProductModal(productId, hideCta = false) {
    this.byoProductModalOutlet.canSubscribeValue = this.#canSubscribe()
    await this.byoProductModalOutlet.show(productId, hideCta)
    window.history.pushState({productId}, '', `?product_id=${productId}`)

    // Ensure newly created product button is up-to-date
    this.updateAddProductButtons(productId)

    this.fireGtag('Learn More Modal Opened', { item: productId })
  }

  productModalClosed() {
    // For deep links, we skip showing the state selector in favor of showing the product modal.
    // So when the product modal is closed, we need to show the state selector.
    if (this.customerStateValue === '') {
      this.showStateSelector()
    }
    window.history.pushState({}, '', window.location.pathname)
  }

  loadProductCard(element) {
    const productId = element.dataset.productId

    if (!productId) {
      console.warn(
        'Product ID not found while initializing product card controller.'
      )
      return
    }

    const template = element.parentElement.querySelector('[data-byo-target="productCardTemplate"]').content.cloneNode(true)
    const productCard = template.querySelector(
      '[data-controller="byo-product-card analytics--product-visibility"]'
    )
    productCard.dataset.byoProductCardProductIdValue = productId
    productCard.dataset.byoProductCardCanSubscribeValue = this.#canSubscribe()

    element.appendChild(template)
  }

  async updateProductCard(element) {
    const hideIfUnavailable = element.dataset.checkAvailability
    let inStock = false
    if (element.dataset.coffeeTier === "Stellar") {
      inStock = (await storefrontRepository.getAvailableUnitsExcludingReserved(element.dataset.variantId, this.customerStateValue)) > 0
    } else {
      inStock = this.inStockSkusValue.includes(element.dataset.sku)
    }

    if (hideIfUnavailable && !inStock) {
      element.classList.add('hidden')
      return
    } else if (element.children.length === 0) {
      // Product card is not loaded yet, load it now.
      this.loadProductCard(element)
    }

    element.classList.remove('hidden')
  }

  filtersChanged({ detail: { filters } }) {
    const hideCategories = filters.length > 0
    this.categoryTargets.forEach(el => el.hidden = hideCategories)
  }

  // returns (###) ###-#### visually while typing in the input
  phoneFormat(e) {
    const currentTarget = e.currentTarget
    const cursorPosition = currentTarget.selectionStart;
    const cleaned = currentTarget.value.replace(/\D/g, '').substring(0, 10);
    let formatted = '';

    // Format the cleaned number
    if (cleaned.length > 0) {
      formatted = '(' + cleaned.substring(0, 3);
    }
    if (cleaned.length > 3) {
      formatted += ') ' + cleaned.substring(3, 6);
    }
    if (cleaned.length > 6) {
      formatted += '-' + cleaned.substring(6, 10);
    }

    const oldLength = currentTarget.value.length;
    currentTarget.value = formatted;
    const newLength = formatted.length;

    // Calculate the new cursor position
    let diff = newLength - oldLength;
    let newCursorPosition = cursorPosition + diff;

    // Adjust the cursor position when user deletes a character
    if (diff < 0 && (formatted.charAt(cursorPosition) === ')' || formatted.charAt(cursorPosition) === '-' || formatted.charAt(cursorPosition) === ' ')) {
      newCursorPosition--;
    }

    // Ensure the cursor position stays within valid range
    newCursorPosition = Math.max(newCursorPosition, 0);
    newCursorPosition = Math.min(newCursorPosition, newLength);

    // Set the new cursor position
    currentTarget.setSelectionRange(newCursorPosition, newCursorPosition);
  }

  updateAllProductCards() {
    this.productCardTargets.forEach((el) => {
      this.updateProductCard(el)
    })

    this.updateAddProductButtons()
  }

  hideEmptyCategories() {
    // Hide any empty categories, and reshow any that have newly in stock products
    // which can happen if a user switches between subscriptions at different
    // addresses.
    this.productCategoryTargets.forEach((el) => {
      if (el.querySelectorAll('[data-sku]:not([hidden])').length === 0) {
        el.hidden = true
      } else {
        el.hidden = false
      }
    })
  }

  showStateSelector() {
    this.stateSelectorTarget.querySelector('dialog').showModal()
    this.stateSelectorSelectTarget.blur()
    this.stateSelectorTarget.querySelector('dialog').dataset.action = 'close->byo#stateSelectorClosed'

    this.fireGtag('State Selector Modal Opened')
  }

  stateSelectorClosed() {
    if (!this.customerStateValue || this.placeholderStateSelected === true) {
      // Refuse to close the modal if the user hasn't selected a state
      this.showStateSelector()
    }
  }

  stateSelectorChange(e) {
    e.preventDefault()

    this.customerStateValue = this.stateSelectorSelectTarget.value
    this.stateSelectorTarget.querySelector('dialog').close()
    this.placeholderStateSelected = false
    this.fireGtag('State Selected', {
      state : this.customerStateValue
    })
  }

  showSMSModal() {
    this.smsModalTarget.querySelector('dialog').showModal()
    this.smsNumPacksTarget.textContent = this.selectedProductsValue.length

    this.fireGtag('SMS Modal Opened')
  }

  userViewablePhoneNumber(phoneNumber) {
    let phoneArray = phoneNumber.split('')

    return "(" + phoneArray.slice(2, 5).join('') + ") " + phoneArray.slice(5, 8).join('') + "-" + phoneArray.slice(8, 12).join('')
  }

  showSMSConfirmationModal(phoneNumber) {
    this.smsConfirmationModalTarget.querySelector('dialog').showModal()
    this.smsPhoneNumberConfirmationTarget.textContent = this.userViewablePhoneNumber(phoneNumber)
  }

  sendSMS(e) {
    e.preventDefault()

    const cartMachine = (0,cart.getCartMachine)()
    const cartToken = cartMachine.state.contents.token.split("?")[0]
    const cartSkus = cartMachine.state.contents.items.map(item => item.sku).join(', ')
    const associateName = this.mallAssociateName
    const checkoutLink = "https://cometeer.com/checkouts/cn/" + cartToken + "?" + "associate=" + encodeURI(associateName) + "&discount=" + encodeURI(this.discountCodeValue)
    const phoneNumber = "+1" + this.phoneNumberInputTarget.value.replace(/\D/g, '');

    const data = {
      phone_number: phoneNumber,
      associate_name: associateName,
      checkout_link: checkoutLink,
      byo_skus: cartSkus,
      mall_name: this.mallName
    };

    fetch(storefront_repository["default"].acrolithSendSMSURL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    }).then((response) => {
      this.fireGtag('Mall Associate Recognition SMS Sent', {
        associateName : associateName
      });

      this.smsModalTarget.querySelector('dialog').close();
      // Give the modal time to close before opening the confirmation modal
      // Since the dialog close overflow setting happens in an event,
      // we need to wait for the event to finish before opening the next modal
      setTimeout(() => {
        this.showSMSConfirmationModal(phoneNumber);
      }, 500);

      return response;
    }).catch((error) => {
      console.error('Send SMS Error:', error);
    });
  }

  async updateCustomizationMakeup() {
    const bundle = this.currentBundle()

    const customizationMakeup = bundle.items.map((item) => ({
      sku: item.sku,
      product_id: item.external_product_id,
      variant_id: item.external_variant_id,
      selected_by: item.source,
      quantity: item.quantity
    }))

    const subscription = await window.recharge.subscription.getSubscription(
      this.sessionValue,
      bundle.purchaseItemId
    )
    const properties = [...subscription.properties]
    const existingMakeup = properties.find(
      (el) => el.name === 'Customization Makeup'
    )
    if (existingMakeup) {
      existingMakeup.value = JSON.stringify(customizationMakeup)
    } else {
      properties.push({
        name: 'Customization Makeup',
        value: JSON.stringify(customizationMakeup)
      })
    }

    await window.recharge.subscription.updateSubscription(
      this.sessionValue,
      bundle.purchaseItemId,
      { properties }
    )
  }

  repeat(n, callback) {
    Array(n).fill(0).map(callback)
  }

  async updateBundle() {
    await window.recharge.bundle.updateBundleSelection(
      this.sessionValue,
      this.selectedBundleIdValue,
      this.currentBundle()
    )

    await this.updateCustomizationMakeup()
  }

  subscriptionChanged({ detail: { bundleId } }) {
    this.updateSelection(bundleId)
  }

  updateSelection(bundleId) {
    this.selectedBundleIdValue = bundleId
  }

  async setEstimatedDeliveryDate(nextChargeDate, state, delivery_zip) {
    const date = await storefront_repository["default"].getEstimatedDeliveryDate(nextChargeDate, state, delivery_zip)
    this.updatedSubscriptionArrivalDateTarget.textContent = this.formatDate(date)
  }

  async loadBundles() {
    const bundleSelections = await (new BundleSelectionLoader).load()
    const filteredBundleSelections = bundleSelections.filter(
      (selection) => selection['subscription'] !== undefined
    ) || []

    if (filteredBundleSelections.length === 0) {
      return // No valid subscriptions
    }

    filteredBundleSelections.sort((a, b) => {
      return (
        Date.parse(a.subscription['next_charge_scheduled_at']) -
        Date.parse(b.subscription['next_charge_scheduled_at'])
      )
    })

    this.activeBundlesValue = filteredBundleSelections
  }

  editBox() {
    this.trayTarget.classList.remove('hidden')
    this.sellingPlansTarget.classList.add('hidden')
    this.trayExpandedValue = true
  }

  maxQty() {
    return (
      this.bundleSettingsValue.variants?.[0]?.ranges?.[0]?.quantity_max || 10
    )
  }

  minQty() {
    if (this.fivePackEnabled) {
      return 5
    } else {
      return (
        this.bundleSettingsValue.variants?.[0]?.ranges?.[0]?.quantity_min || 4
      )
    }
  }

  updateAddProductButtons(productId = undefined) {
    this.addProductButtonTargets.forEach((el) => {
      if (productId && el.dataset.productId !== productId) {
        return
      }

      this.updateAddProductButton(el)
    })
  }

  updateAddProductButton(el) {
    if(el.dataset.alwaysDisable === 'true') { return }

    const requiresStock = el.dataset.requiresStock === 'true'
    const inStock = this.inStockSkusValue.includes(el.dataset.productSku)
    const productId = el.dataset.productId
    const countOfSelected = this.selectedProductsValue.filter(
      (product) => product.id === productId
    ).length
    const originalButtonText = el.dataset.originalText || 'Add'

    if (requiresStock && this.customerStateValue === '') {
      el.querySelector('span').textContent = 'Check Availability (Select State)'
      el.dataset.action = 'click->byo#showStateSelector'
      el.disabled = false
    } else if (requiresStock && !inStock) {
      el.querySelector('span').textContent = 'Currently Unavailable'
      el.disabled = true
    } else {
      const buttonText =
        countOfSelected === 0
          ? originalButtonText
          : countOfSelected === 1
            ? '1 Pack'
            : `${countOfSelected} Packs`

      el.querySelector('span').textContent = buttonText
      el.dataset.productCurrentQty = countOfSelected
      el.dataset.action = 'click->byo#onAddProduct'
      el.disabled = false
    }
  }

  updateTrayDetails() {
    if (this.selectedProductsValue.length > 0) {
      const totalSubscribePrice = this.selectedProductsValue.reduce(
        (acc, val) => acc + val.subscribePrice,
        0
      )
      const totalOnetimePrice = this.selectedProductsValue.reduce(
        (acc, val) => acc + val.onetimePrice,
        0
      )
      const totalSubscribePricePerCapsule = this.selectedProductsValue.reduce(
        (acc, val) => acc + val.subscribePricePerCapsule,
        0
      ) / this.selectedProductsValue.length
      const totalOnetimePricePerCapsule = this.selectedProductsValue.reduce(
        (acc, val) => acc + val.onetimePricePerCapsule,
        0
      ) / this.selectedProductsValue.length
      const totalCapsules = this.selectedProductsValue.reduce(
        (acc, val) => acc + val.capsulesCount,
        0
      )
      const crossOutPrice =
        totalOnetimePrice !== totalSubscribePrice
          ? `<del>${(0,format_money.formatMoney)(totalOnetimePrice)}</del>`
          : ''
      const ctaText = () => {
        if (this.selectedBundleIdValue) {
          return 'Update Subscription -'
        } else if (this.displayOtpButtonTextValue) {
          return 'Order from'
        } else {
          return ''
        }
      }
      const quantitySelected = this.selectedProductsValue.length

      this.onetimePriceTargets.forEach((el) => { el.textContent = (0,format_money.formatMoney)(totalOnetimePrice) })
      this.onetimePriceUnitTargets.forEach((el) => {
        el.textContent = `${(0,format_money.formatMoney)(totalOnetimePricePerCapsule)}/capsule`
      })
      this.subscribePriceUnitTargets.forEach((el) => {
        el.textContent = `${(0,format_money.formatMoney)(totalSubscribePricePerCapsule)}/capsule`
      })
      this.subscribePriceTargets.forEach((el) => {
        el.innerHTML = `${crossOutPrice}<b class="font-medium">${(0,format_money.formatMoney)(
          totalSubscribePrice
        )}</b>`
      })
      this.discountTextTargets.forEach((el) => {
        el.textContent = `SAVE ${(0,format_money.formatMoney)(totalOnetimePrice - totalSubscribePrice)}`
      })
      this.ctaTargets.forEach((el) => {
        if (this.bundleFromCart) {
          // Price determined by cart, to take discounts into account.
          el.textContent = `${ctaText()} ${(0,format_money.formatMoney)(this.bundlePriceFromCart * 100)}`
        } else {
          el.textContent = `${ctaText()} ${(0,format_money.formatMoney)(
            this.#canSubscribe() ? totalSubscribePrice : totalOnetimePrice
          )}`
        }
      })
      this.trayDetailsButtonTarget.classList.toggle(
        'hidden',
        quantitySelected <= 0
      )

      let traySummaryText = ''
      if (quantitySelected < this.minQty()) {
        traySummaryText = `<b>Choose ${this.minQty() - quantitySelected} more packs</b>`
      } else {
        traySummaryText = `<b>${quantitySelected} Packs</b> ${totalCapsules} capsules`
      }
      this.traySummaryTargets.forEach((el) => (el.innerHTML = traySummaryText))
    } else {
      this.onetimePriceTargets.forEach((el) => { el.textContent = '' })
      this.onetimePriceUnitTargets.forEach((el) => { el.textContent = '' })
      this.subscribePriceUnitTargets.forEach((el) => { el.textContent = '' })
      this.subscribePriceTargets.forEach((el) => { el.textContent = '' })
      this.discountTextTargets.forEach((el) => { el.textContent = '' })
      this.ctaTargets.forEach((el) => { el.textContent = `Choose ${this.minQty()} packs` })
      this.trayDetailsButtonTarget.classList.add('hidden')

      const traySummaryText = `<b>Choose ${this.minQty()} packs</b>`
      this.traySummaryTargets.forEach((el) => (el.innerHTML = traySummaryText))
    }

    this.setExistingSubscriptionIntervalSelection()
    this.ctaTargets.forEach((el) => {
      el.disabled = this.selectedProductsValue.length < this.minQty()
    })
  }

  setExistingSubscriptionIntervalSelection() {
    if (this.hasSellingPlanSelectorTarget) {
      this.toggleSellingPlanSelector()

      const selection = this.activeBundlesValue.find(
        (el) => el.id === this.selectedBundleIdValue
      )

      if (selection?.subscription?.charge_interval_frequency && this.activeSellingPlanSelector()) {
        const interval_frequency = selection.subscription.charge_interval_frequency
        const plan_weeks = interval_frequency === 1 ? 'week' : 'weeks'

        this.activeSellingPlanSelector().value = `Delivery every ${selection.subscription.charge_interval_frequency} ${plan_weeks}`
      } else {
        this.activeSellingPlanSelector().value = 'Delivery every 4 weeks'
      }
    }
  }

  async fetchProduct(productId) {
    const fetchedProduct = await storefront_repository["default"].getProduct(productId)
    // Because the product we get is memoized, we need to clone it to avoid
    // modifying the original object.
    const product = structuredClone(fetchedProduct)

    const capsuleCount = product.capsulesCount?.value || 1
    const variant = (
      product.variants.edges.find((v) => {
        v.node.selectedOptions[0].value === '8ct'
      }) || product.variants.edges[0]
    ).node
    const subscribePrice =
      (product.subscriptionDisplayPrice?.value ||
        variant.sellingPlanAllocations.edges[0]?.node?.priceAdjustments[0]
          ?.price?.amount ||
        variant.price.amount) * 100
    const oneTimePrice =
      (product.onetimeDisplayPrice?.value || variant.price.amount) * 100
    const productImage =
      product.trayImage?.reference?.image?.url ||
      product.roaster?.reference?.cometeerLogo?.reference?.image?.url ||
      product.bundleImage?.reference?.image?.url ||
      product.featuredImage.url

    product.id = product.id.replace(/^\D+/g, '')
    ;(product.capsulesCount = parseInt(capsuleCount)),
      (product.subscribePrice = subscribePrice),
      (product.subscribePricePerCapsule = subscribePrice / capsuleCount),
      (product.onetimePrice = oneTimePrice),
      (product.onetimePricePerCapsule = oneTimePrice / capsuleCount),
      (product.image = productImage),
      (product.roasterName = product.roaster?.reference?.name?.value),
      (product.roastLevel = product.roastLevel?.value)
    product.collection_id = this.collectionIdValue
    product.variantId = variant.id.replace(/^\D+/g, '')
    product.source = product.source || 'customer'
    product.sku = variant.sku
    product.quantity = 1

    return product
  }

  showError(message, target) {
    const flashMessage = this.flashMessageTemplateTarget.content.cloneNode(true)
    flashMessage.querySelector(
      '[data-flash-target="text-content"]'
    ).textContent = message
    target.appendChild(flashMessage)
    const flashMessageEl = target.lastElementChild

    setTimeout(() => {
      flashMessageEl.classList.remove('opacity-0', 'scale-50', 'max-h-0')
    }, 0)

    setTimeout(async () => {
      flashMessageEl.classList.remove('max-h-8')
      flashMessageEl.classList.add('opacity-0', 'scale-50', 'max-h-0')
      await new Promise((resolve) => setTimeout(resolve, 150))
      target.removeChild(flashMessageEl)
    }, 5000)
  }

  showSubscriptionModalState(state) {
    this.subscriptionUpdateDialogTarget
      .querySelectorAll('[data-identifier]')
      .forEach((child) => child.classList.add('hidden'))
    this.subscriptionUpdateDialogTarget
      .querySelector(`[data-identifier="${state}"]`)
      .classList.remove('hidden')

    this.subscriptionUpdateDialogTarget.querySelector('dialog').showModal()
  }

  hideSubscriptionModal() {
    this.subscriptionUpdateDialogTarget.querySelector('dialog').close()
  }

  processNow(e) {
    e.preventDefault()
    this.fireGtag('Ship Now Clicked')

    // Give gtag time to send.
    setTimeout(() => {
      processNow(this.currentBundle().purchaseItemId)
    }, 0)
  }

  formatDate(date) {
    return dayjs_min_default()(date).format('MMMM D, YYYY')
  }

  async submitSubscriptionUpdate() {
    this.ctaTargets.forEach((el) => {
      el.disabled = true
      el.innerText = 'Updating...'
    })

    this.showSubscriptionModalState('loading')

    try {
      await this.updateBundle()
      await this.loadBundles()

      const selection = this.activeBundlesValue.find(
        (el) => el.id === this.selectedBundleIdValue
      )

      if (selection?.subscription?.charge_interval_frequency && this.activeSellingPlanSelector()) {
        const existing_interval_frequency = selection.subscription.charge_interval_frequency
        const selected_interval_frequency = this.activeSellingPlanSelector().value.split(' ')[2]
        if (existing_interval_frequency != selected_interval_frequency) {
          await window.recharge.subscription.updateSubscription(
            this.sessionValue,
            selection.subscription.id,
            {
              charge_interval_frequency: selected_interval_frequency,
              order_interval_frequency: selected_interval_frequency,
              order_interval_unit: "week",
            }
          )

          await this.updateBundle()
          await this.loadBundles()
        }
      }

      this.updatedSubscriptionDateTarget.textContent = this.formatDate(selection.subscription.next_charge_scheduled_at)
      this.updatedSubscriptionAddressTarget.textContent = selection.address.address1
      this.setEstimatedDeliveryDate(
        selection.subscription.next_charge_scheduled_at,
        selection.address.province,
        selection.address.zip
      )
      // Clear the items (in case we've previously used this).
      this.updatedSubscriptionItemsTarget.innerHTML = ""
      this.selectedProductsValue.forEach(product => {
        const slot = this.updatedSubscriptionItemTemplateTarget.content.cloneNode(true)
        slot.querySelector('div').style.backgroundImage = `url('${product.image}')`
        slot.querySelector('div').dataset.slot = product.id
        this.updatedSubscriptionItemsTarget.appendChild(slot)
      })

      this.showSubscriptionModalState('success')
      this.ctaTargets.forEach((el) => { el.disabled = false })
      this.updateTrayDetails() // To reset button text

      this.fireGtag('Save Subscription')
    } catch (e) {
      console.error(e)

      this.ctaTargets.forEach((el) => {
        el.disabled = false
        el.innerText = 'Failed to update'
      })

      this.showSubscriptionModalState('failure')

      setTimeout(() => {
        this.hideSubscriptionModal()
      }, 4000)
    }
  }

  currentBundleItems() {
    const uniqueSelectedProducts = this.selectedProductsValue.reduce(
      (acc, val) => {
        const existing = acc.find((el) => el.id === val.id)
        if (existing) {
          existing.quantity += 1
        } else {
          acc.push({ ...val, quantity: 1 })
        }
        return acc
      },
      []
    )

    return uniqueSelectedProducts.map((product) => {
      return {
        collection_id: product.collection_id,
        collection_source: 'shopify',
        external_product_id: product.id,
        external_variant_id: product.variantId,
        source: product.source,
        sku: product.sku,
        quantity: product.quantity,
        sellingPlanGroups: product.sellingPlanGroups?.nodes[0]?.sellingPlans?.nodes
      }
    })
  }

  currentBundle() {
    const selection = this.activeBundlesValue.find(
      (el) => el.id === this.selectedBundleIdValue
    )

    return {
      external_product_id: this.bundleProductIdValue,
      external_variant_id: this.bundleVariantIdValue,
      items: this.currentBundleItems(),
      purchaseItemId: selection?.purchase_item_id
    }
  }

  async ctaSubmit(e) {
    e.preventDefault()

    if (this.bundleFromCart) {
      // Just open the sidecart and return.
      this.sidecartOutlet.open()
      return
    }

    if (this.selectedBundleIdValue !== 0) {
      const bundleValidity = await this.sidecartOutlet.checkBundleValidity(this.currentBundle(), this.minQty())

      if (!bundleValidity) {
        return
      }

      this.submitSubscriptionUpdate()
    } else {
      const sellingPlanOptions = this.ctaInputTargets.map((el) => el.querySelector('input').value)

      if (sellingPlanOptions.length > 1 || sellingPlanOptions.includes('onetime-gift')) {
        // There are multiple CTA options, or we require recipient
        // information for a gift, show them to the user.
        this.trayTarget.classList.add('hidden')
        this.sellingPlansTarget.classList.remove('hidden')
      } else {
        // There's only one option - go ahead and trigger it.
        this.ctaInputTarget.querySelector('input').checked = true
        this.addToCart()
      }
    }
  }

  async onAddProduct(event) {
    event.preventDefault()

    const productId = event.currentTarget.dataset.productId
    const variantId = event.currentTarget.dataset.variantId
    const priceCents = event.currentTarget.dataset.variantPrice

    this.addProduct(productId)

    const categoryTarget = event.currentTarget.closest('[data-byo-target="category"]')
    const categoryIndex = categoryTarget ? this.categoryTargets.indexOf(categoryTarget) : null

    const siblings = categoryTarget ? Array.from(categoryTarget.querySelectorAll('[data-byo-target="productCard"]:not(.hidden)')) : []
    const position = siblings.indexOf(event.currentTarget.closest('[data-byo-target="productCard"]'))

    this.fireGtag('Add Sleeve', {
      item: productId,
      variant: variantId,
      priceCents: priceCents,
      section: categoryIndex + 1,
      position: position + 1,
    })
  }

  async addProduct(productId, item = null) {
    if (this.stateSelectorDelayedValue && this.placeholderStateSelected) {
      this.showStateSelector()
    }

    // Already adding a product, return early
    if (this.addingProductValue) {
      return
    }

    // Tray is full, show error message
    if (this.selectedProductsValue.length === this.maxQty()) {
      const message = 'Oh no, your cart is full. Remove a flavor to make another selection.'

      const modalFeedbackTarget = this.feedbackContainerTargets.find((el) => el.closest('dialog').dataset.productId === productId)
      if(modalFeedbackTarget && modalFeedbackTarget.checkVisibility()) {
        this.showError(message, modalFeedbackTarget)
      } else {
        this.showError(message, this.flashContainerTarget)
      }

      return
    }

    this.addingProductValue = true

    try {
      const product = await this.fetchProduct(productId)
      if (item) {
        // Add the line item to the product object so we can reference it later
        // if product is being added from a cart bundle
        product.item = item
      } else {
        // Mark the cart bundle as needing an update, as we're adding a new product.
        this.needsUpdate = true
      }
      this.selectedProductsValue = [...this.selectedProductsValue, product]
      this.addingProductValue = false
    } catch (error) {
      // Ensure we don't get stuck in the adding state
      this.addingProductValue = false
      console.error('Failed to add product to tray', error)
      this.showError('Something went wrong, please try again.')
    }
  }

  onRemoveProduct(event) {
    event.preventDefault();

    const productId = event.currentTarget.dataset.productId
    const variantId = event.currentTarget.dataset.variantId
    const priceCents = event.currentTarget.dataset.variantPrice

    this.needsUpdate = true
    if (event.currentTarget.dataset.index !== undefined) {
      const index = Number(event.currentTarget.dataset.index)
      this.removeProductByIndex(index)
    } else {
      this.removeProductById(productId)
    }

    this.fireGtag('Remove Sleeve', {
      item: productId,
      variantId: variantId,
      priceCents: priceCents
    })
  }

  removeProductByIndex(index) {
    this.selectedProductsValue = this.selectedProductsValue.filter(
      (_, i) => i !== index
    )
  }

  removeProductById(productId) {
    const index = this.selectedProductsValue.findLastIndex(
      (el) => el.id === productId
    )
    this.removeProductByIndex(index)
  }

  async checkStockAtCustomerState() {
    try {
      this.inStockSkusValue = await storefront_repository["default"].getAvailableSkus(this.customerStateValue)
    } catch (error) {
      console.error(error)
    }
    this.hideEmptyCategories()
  }

  fireGtag(name, dataToAdd = undefined) {
    const currentBundle = this.currentBundle()
    const eventData = {
      newSubscription: this.selectedBundleIdValue === 0,
      bundleSelectionId: this.bundleSettingsValue.id,
      subcriptionId: currentBundle.purchaseItemId,
      items: currentBundle.items // this is not actually passed to gtm
    }

    Object.assign(eventData, dataToAdd)
    window.gtag('event', `Box Configurator - ${name}`, eventData)
  }

  sellingPlanName() {
    const sellingPlan =
        this.sellingPlansTarget.querySelector(
          'input[name="selling_plan"]:checked'
        ).value || 'onetime'

    if (sellingPlan == 'onetime') {
      return sellingPlan
    } else {
      let chosenPlanName = ''
      if (this.activeSellingPlanSelector()) {
        chosenPlanName = this.activeSellingPlanSelector().value.toUpperCase()
      } else {
        chosenPlanName = 'DELIVERY EVERY 4 WEEKS'
      }

      return chosenPlanName
    }
  }

  async addToCart(event = undefined) {
    event?.preventDefault()
    const giftData = event && event.target instanceof HTMLFormElement ? new FormData(event.srcElement) : null
    const giftProperties = {}
    if (giftData && giftData.has('attributes[recipient_email]')) {
      giftProperties['Recipient email'] = giftData.get('attributes[recipient_email]')
      giftProperties['Message'] = giftData.get('attributes[gift_message]')
      giftProperties['__allow_date_picker'] = true
    }

    await this.sidecartOutlet.addItems(this.bundleToCartItems())
    await this.sidecartOutlet.setDiscountCodes(this.discountCodesValue)

    const shortlinkSlug = (0,value_from_cookie.valueFromCookie)('shortlink_slug')[0]
    if (shortlinkSlug) {
      await this.sidecartOutlet.setCartAttributes({ key: 'shortlinkSlug', value: shortlinkSlug })
    }

    const associateName = this.mallAssociateName

    if (this.sellingPlansTarget.querySelector(
      'input[name="selling_plan"]:checked'
    ).value === 'sms') {
      if(associateName) {
        this.fireGtag('Field: SMS Option Chosen')
      }

      this.showSMSModal()
    } else {
      if (associateName) {
        this.fireGtag('Field: Checkout Option Chosen')

        storefront.navigateToCheckout(`associate=${encodeURI(associateName)}`)
      } else {
        storefrontRepository.navigateToCheckout()
      }
    }
  }

  // --- Value change handlers ---

  async activeBundlesValueChanged() {
    const supportedSubscriptions = this.#supportedSubscriptions()

    if (supportedSubscriptions.length > 1) {
      this.byoSubscriptionsOutlet.render_subscription_picker()
      this.subscriptionSelectorTarget.classList.remove('hidden')
    } else if (supportedSubscriptions.length === 0) {
      return
    }

    this.byoSubscriptionsOutlet.render_subscription_list(supportedSubscriptions)

    if (this.selectedBundleIdValue === 0) {
      this.selectedBundleIdValue = supportedSubscriptions[0]?.id
    }
  }

  async selectedBundleIdValueChanged() {
    const selection = this.activeBundlesValue.find(
      (el) => el.id === this.selectedBundleIdValue
    )

    if (this.hasInlineStateSelectorTarget) {
      this.inlineStateSelectorTarget.classList.toggle('hidden', selection !== undefined)
    }

    if (!selection) {
      // All new BYO subscriptions get the 5 pack minimum
      this.toggleFivePack(true)

      return
    }

    // Existing subscribers get the 5 pack minimum if they have the tag
    if (checkFivePackTag()) {
      this.toggleFivePack(true)
    } else {
      this.toggleFivePack(false)
    }

    this.customerStateValue = selection.address['province']
    this.placeholderStateSelected = false

    this.byoSubscriptionsOutlet.render_selection(selection)

    // Add existing products to tray
    let products = []
    const sortedItems = selection['items'].sort((a) =>
      constants.BOX_PRODUCT_IDS.includes(a['external_product_id']) ? -1 : 1
    )

    for (const item of sortedItems) {
      const product = await this.fetchProduct(item['external_product_id'])

      // Find customization makeup - if any - and only use each item once.
      const makeupMatchesItem = (m) =>
        m.variant_id === item.external_variant_id &&
        m.quantity === item.quantity
      const idx = selection.customizationMakeup.findIndex(makeupMatchesItem)
      if (idx === -1) {
        // We could not find the matching makeup property, best effort:
        product.source = 'preset'
      }
      product.source = selection.customizationMakeup.splice(idx, 1)[0]?.[
        'selected_by'
        ]

      this.repeat(item['quantity'], () => {
        products.push(product)
      })
    }
    this.selectedProductsValue = products

    this.fireGtag('Open Subscription')
  }

  async customerStateValueChanged(value, previousValue) {
    if (!this.customerStateValue) {
      return
    }

    if (this.hasInlineStateSelectorOutlet && this.inlineStateSelectorOutlet.selectedStateValue !== this.customerStateValue) {
      this.inlineStateSelectorOutlet.selectedStateValue = this.customerStateValue
    }

    if ((previousValue === undefined || previousValue === '') && (value !== undefined || value !== '')) {
      this.afterStateSelected()
    }

    this.checkStockAtCustomerState()

    if (this.hasByoFiltersOutlet) {
      this.byoFiltersOutlet.search()
    }
  }

  inStockSkusValueChanged() {
    this.updateAllProductCards()
  }

  trayExpandedValueChanged() {
    this.trayDetailsTarget.dataset.expanded = this.trayExpandedValue
    this.trayOverlayTarget.style.display = this.trayExpandedValue
      ? 'block'
      : 'none'
    const textToUse = this.trayExpandedValue ? 'Hide Details' : 'View Details'
    this.trayDetailsButtonTarget.textContent = textToUse

    if (this.trayExpandedValue) {
      this.fireGtag('View Tray Details')
    }
  }

  bundleSettingsValueChanged() {
    this.updateTrayDetails()
  }

  async selectedProductsValueChanged(val, prevVal) {
    this.trayContainerTarget.classList.remove('hidden')
    const availableSkus = await storefront_repository["default"].getAvailableSkus(this.customerStateValue)

    this.updateTrayDetails()
    this.updateAddProductButtons()

    if (val.length !== prevVal?.length) {
      // We know the bundle items have changed (as opposed to the item contents changing)
      // so we can trigger a cart update with a lock.
      this.pendingCartUpdate = true
      this.updateCartBundleWithLock()
    }

    // Clear tray slots, replace with template slots
    this.traySlotTargets.forEach((el) => el.remove())
    for (let idx = 0; idx < this.maxQty(); idx++) {
      const slot = this.traySlotTemplateTarget.content.cloneNode(true)
      slot.children[0].dataset.byoTarget = 'traySlot'
      slot.children[0].dataset.action = 'click->byo#toggleTray'

      switch (idx) {
        case 3:
          this.sleeve4TextTarget.classList.remove('hidden');
          slot.children[0].appendChild(this.sleeve4TextTarget);
          break;
        case 4:
          this.sleeve5TextTarget.classList.remove('hidden');
          slot.children[0].appendChild(this.sleeve5TextTarget);
          break;
        case 5:
          this.sleeve6TextTarget.classList.remove('hidden');
          slot.children[0].appendChild(this.sleeve6TextTarget);
          break;
      }

      this.trayDetailsTarget.append(slot)
    }

    if (this.selectedProductsValue.length <= 0) {
      this.trayExpandedValue = false
    }

    this.selectedProductsValue.forEach((product, index) => {
      const slotToFill = this.trayDetailsTarget.querySelector(
        "[data-slot='empty']"
      )
      var productName = product.roasterName
        ? `${product.roasterName} — ${product.title}`
        : product.title
      const template = this.trayProductTemplateTarget.content.cloneNode(true)
      var available = true

      if (product.productType === "Coffee Sleeve") {
        available = availableSkus.includes(product.variants.edges[0].node.sku)
      }

      if (!available) {
        productName = "Coffee Unavailable"
        template.querySelector(
          '[data-product-roast-level]'
        ).innerText = "We'll replace this with a similar coffee at the same price."
        template.querySelector('[data-product-img').style.opacity = 0.25;
        template.querySelector('[data-product-out-of-stock-img').classList.remove('hidden')
      }

      template.querySelector('[data-product-title]').innerText = productName
      template.querySelector(
        '[data-product-img]'
      ).style.backgroundImage = `url('${product.image}')`
      template.querySelector(`[data-product-price]`).innerText = (0,format_money.formatMoney)(
        this.#canSubscribe() ? product.subscribePrice : product.onetimePrice
      )
      template
        .querySelectorAll('[data-index]')
        .forEach((el) => (el.dataset.index = `${index}`))
      template
        .querySelectorAll('[data-product-id]')
        .forEach((el) => (el.dataset.productId = product.id))
      template
        .querySelectorAll('[data-variant-id]')
        .forEach((el) => (el.dataset.variantId = product.variantId))
      if (product.subscribePrice) {
        template
          .querySelectorAll('[data-variant-price]')
          .forEach((el) => (el.dataset.variantPrice = product.subscribePrice))
      }
      if (product.roastLevel !== undefined && this.available) {
        template.querySelector(
          '[data-product-roast-level]'
        ).innerText = `${product.roastLevel} Roast`
      }
      if (product.capsulesCount > 1 && product.subscribePrice) {
        const pricePerCapsule = this.#canSubscribe() ? product.subscribePricePerCapsule : product.onetimePricePerCapsule
        const capsuleCountText = `${
          product.capsulesCount
        } capsules / ${(0,format_money.formatMoney)(pricePerCapsule)} each`
        template.querySelector(`[data-capsule-count]`).style.display = 'inherit'
        template.querySelector(`[data-capsule-count]`).innerText =
          capsuleCountText
      }

      slotToFill.querySelector('[data-placeholder]').classList.add('hidden')
      slotToFill.dataset.slot = product.id
      slotToFill.append(template)
    })

    if (this.selectedProductsValue.length > 6) {
      this.sleeveCounterTarget.classList.remove('hidden')
      // We take up the 6th slot, so subtract by 5.
      this.sleeveCounterTarget.textContent = `+${this.selectedProductsValue.length - 5}`
    } else {
      this.sleeveCounterTarget.classList.add('hidden')
    }

    this.toggleSellingPlanSelector()
  }

  toggleSellingPlanSelector() {
    const meetsMinCountRequirement = this.selectedProductsValue.length >= this.minSleevesForIntervalSelectorValue

    this.sellingPlanSelectorTargets.forEach((sellingPlanSelectorElement) => {
      const isSubscriptionAudience = sellingPlanSelectorElement.dataset.subscriptionAudience === 'true'

      sellingPlanSelectorElement.classList.toggle(
        'hidden',
        !meetsMinCountRequirement || (this.selectedBundleIdValue ? !isSubscriptionAudience : isSubscriptionAudience)
      )
    })
  }

  activeSellingPlanSelector() {
    if (this.selectedBundleIdValue) {
      return this.sellingPlanSelectorTargets.find((sellingPlanSelectorElement) =>
        sellingPlanSelectorElement.dataset.subscriptionAudience === 'true'
      )
    } else {
      return this.sellingPlanSelectorTargets.find((sellingPlanSelectorElement) =>
        sellingPlanSelectorElement.dataset.subscriptionAudience !== 'true'
      )
    }
  }

  #canSubscribe() {
    return this.showSubscriptionPriceValue
  }

  #supportedSubscriptions() {
    return(
      this.activeBundlesValue.filter(
        (selection) => selection['external_product_id'] === constants.COFFEE_BUNDLE_PRODUCT_ID
      )
    )
  }
}

Stimulus.register("byo", ByoController)


/***/ }),

/***/ 7672:
/***/ (function(module) {

!function(t,e){ true?module.exports=e():0}(this,(function(){"use strict";var t=1e3,e=6e4,n=36e5,r="millisecond",i="second",s="minute",u="hour",a="day",o="week",c="month",f="quarter",h="year",d="date",l="Invalid Date",$=/^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/,y=/\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,M={name:"en",weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),ordinal:function(t){var e=["th","st","nd","rd"],n=t%100;return"["+t+(e[(n-20)%10]||e[n]||e[0])+"]"}},m=function(t,e,n){var r=String(t);return!r||r.length>=e?t:""+Array(e+1-r.length).join(n)+t},v={s:m,z:function(t){var e=-t.utcOffset(),n=Math.abs(e),r=Math.floor(n/60),i=n%60;return(e<=0?"+":"-")+m(r,2,"0")+":"+m(i,2,"0")},m:function t(e,n){if(e.date()<n.date())return-t(n,e);var r=12*(n.year()-e.year())+(n.month()-e.month()),i=e.clone().add(r,c),s=n-i<0,u=e.clone().add(r+(s?-1:1),c);return+(-(r+(n-i)/(s?i-u:u-i))||0)},a:function(t){return t<0?Math.ceil(t)||0:Math.floor(t)},p:function(t){return{M:c,y:h,w:o,d:a,D:d,h:u,m:s,s:i,ms:r,Q:f}[t]||String(t||"").toLowerCase().replace(/s$/,"")},u:function(t){return void 0===t}},g="en",D={};D[g]=M;var p="$isDayjsObject",S=function(t){return t instanceof _||!(!t||!t[p])},w=function t(e,n,r){var i;if(!e)return g;if("string"==typeof e){var s=e.toLowerCase();D[s]&&(i=s),n&&(D[s]=n,i=s);var u=e.split("-");if(!i&&u.length>1)return t(u[0])}else{var a=e.name;D[a]=e,i=a}return!r&&i&&(g=i),i||!r&&g},O=function(t,e){if(S(t))return t.clone();var n="object"==typeof e?e:{};return n.date=t,n.args=arguments,new _(n)},b=v;b.l=w,b.i=S,b.w=function(t,e){return O(t,{locale:e.$L,utc:e.$u,x:e.$x,$offset:e.$offset})};var _=function(){function M(t){this.$L=w(t.locale,null,!0),this.parse(t),this.$x=this.$x||t.x||{},this[p]=!0}var m=M.prototype;return m.parse=function(t){this.$d=function(t){var e=t.date,n=t.utc;if(null===e)return new Date(NaN);if(b.u(e))return new Date;if(e instanceof Date)return new Date(e);if("string"==typeof e&&!/Z$/i.test(e)){var r=e.match($);if(r){var i=r[2]-1||0,s=(r[7]||"0").substring(0,3);return n?new Date(Date.UTC(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)):new Date(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)}}return new Date(e)}(t),this.init()},m.init=function(){var t=this.$d;this.$y=t.getFullYear(),this.$M=t.getMonth(),this.$D=t.getDate(),this.$W=t.getDay(),this.$H=t.getHours(),this.$m=t.getMinutes(),this.$s=t.getSeconds(),this.$ms=t.getMilliseconds()},m.$utils=function(){return b},m.isValid=function(){return!(this.$d.toString()===l)},m.isSame=function(t,e){var n=O(t);return this.startOf(e)<=n&&n<=this.endOf(e)},m.isAfter=function(t,e){return O(t)<this.startOf(e)},m.isBefore=function(t,e){return this.endOf(e)<O(t)},m.$g=function(t,e,n){return b.u(t)?this[e]:this.set(n,t)},m.unix=function(){return Math.floor(this.valueOf()/1e3)},m.valueOf=function(){return this.$d.getTime()},m.startOf=function(t,e){var n=this,r=!!b.u(e)||e,f=b.p(t),l=function(t,e){var i=b.w(n.$u?Date.UTC(n.$y,e,t):new Date(n.$y,e,t),n);return r?i:i.endOf(a)},$=function(t,e){return b.w(n.toDate()[t].apply(n.toDate("s"),(r?[0,0,0,0]:[23,59,59,999]).slice(e)),n)},y=this.$W,M=this.$M,m=this.$D,v="set"+(this.$u?"UTC":"");switch(f){case h:return r?l(1,0):l(31,11);case c:return r?l(1,M):l(0,M+1);case o:var g=this.$locale().weekStart||0,D=(y<g?y+7:y)-g;return l(r?m-D:m+(6-D),M);case a:case d:return $(v+"Hours",0);case u:return $(v+"Minutes",1);case s:return $(v+"Seconds",2);case i:return $(v+"Milliseconds",3);default:return this.clone()}},m.endOf=function(t){return this.startOf(t,!1)},m.$set=function(t,e){var n,o=b.p(t),f="set"+(this.$u?"UTC":""),l=(n={},n[a]=f+"Date",n[d]=f+"Date",n[c]=f+"Month",n[h]=f+"FullYear",n[u]=f+"Hours",n[s]=f+"Minutes",n[i]=f+"Seconds",n[r]=f+"Milliseconds",n)[o],$=o===a?this.$D+(e-this.$W):e;if(o===c||o===h){var y=this.clone().set(d,1);y.$d[l]($),y.init(),this.$d=y.set(d,Math.min(this.$D,y.daysInMonth())).$d}else l&&this.$d[l]($);return this.init(),this},m.set=function(t,e){return this.clone().$set(t,e)},m.get=function(t){return this[b.p(t)]()},m.add=function(r,f){var d,l=this;r=Number(r);var $=b.p(f),y=function(t){var e=O(l);return b.w(e.date(e.date()+Math.round(t*r)),l)};if($===c)return this.set(c,this.$M+r);if($===h)return this.set(h,this.$y+r);if($===a)return y(1);if($===o)return y(7);var M=(d={},d[s]=e,d[u]=n,d[i]=t,d)[$]||1,m=this.$d.getTime()+r*M;return b.w(m,this)},m.subtract=function(t,e){return this.add(-1*t,e)},m.format=function(t){var e=this,n=this.$locale();if(!this.isValid())return n.invalidDate||l;var r=t||"YYYY-MM-DDTHH:mm:ssZ",i=b.z(this),s=this.$H,u=this.$m,a=this.$M,o=n.weekdays,c=n.months,f=n.meridiem,h=function(t,n,i,s){return t&&(t[n]||t(e,r))||i[n].slice(0,s)},d=function(t){return b.s(s%12||12,t,"0")},$=f||function(t,e,n){var r=t<12?"AM":"PM";return n?r.toLowerCase():r};return r.replace(y,(function(t,r){return r||function(t){switch(t){case"YY":return String(e.$y).slice(-2);case"YYYY":return b.s(e.$y,4,"0");case"M":return a+1;case"MM":return b.s(a+1,2,"0");case"MMM":return h(n.monthsShort,a,c,3);case"MMMM":return h(c,a);case"D":return e.$D;case"DD":return b.s(e.$D,2,"0");case"d":return String(e.$W);case"dd":return h(n.weekdaysMin,e.$W,o,2);case"ddd":return h(n.weekdaysShort,e.$W,o,3);case"dddd":return o[e.$W];case"H":return String(s);case"HH":return b.s(s,2,"0");case"h":return d(1);case"hh":return d(2);case"a":return $(s,u,!0);case"A":return $(s,u,!1);case"m":return String(u);case"mm":return b.s(u,2,"0");case"s":return String(e.$s);case"ss":return b.s(e.$s,2,"0");case"SSS":return b.s(e.$ms,3,"0");case"Z":return i}return null}(t)||i.replace(":","")}))},m.utcOffset=function(){return 15*-Math.round(this.$d.getTimezoneOffset()/15)},m.diff=function(r,d,l){var $,y=this,M=b.p(d),m=O(r),v=(m.utcOffset()-this.utcOffset())*e,g=this-m,D=function(){return b.m(y,m)};switch(M){case h:$=D()/12;break;case c:$=D();break;case f:$=D()/3;break;case o:$=(g-v)/6048e5;break;case a:$=(g-v)/864e5;break;case u:$=g/n;break;case s:$=g/e;break;case i:$=g/t;break;default:$=g}return l?$:b.a($)},m.daysInMonth=function(){return this.endOf(c).$D},m.$locale=function(){return D[this.$L]},m.locale=function(t,e){if(!t)return this.$L;var n=this.clone(),r=w(t,e,!0);return r&&(n.$L=r),n},m.clone=function(){return b.w(this.$d,this)},m.toDate=function(){return new Date(this.valueOf())},m.toJSON=function(){return this.isValid()?this.toISOString():null},m.toISOString=function(){return this.$d.toISOString()},m.toString=function(){return this.$d.toUTCString()},M}(),k=_.prototype;return O.prototype=k,[["$ms",r],["$s",i],["$m",s],["$H",u],["$W",a],["$M",c],["$y",h],["$D",d]].forEach((function(t){k[t[1]]=function(e){return this.$g(e,t[0],t[1])}})),O.extend=function(t,e){return t.$i||(t(e,_,O),t.$i=!0),O},O.locale=w,O.isDayjs=S,O.unix=function(t){return O(1e3*t)},O.en=D[g],O.Ls=D,O.p={},O}));

/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ __webpack_require__.O(0, [957], () => (__webpack_exec__(432)));
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ }
]);